import { isComplexEntityType } from "../../../../../../../utils/utils";
import { applySearchFilter } from "../../shared/controlEntitiesUtils";
import {
  createFallbackSimpleEntitiesFromComplexIds,
  mergeEntitiesByType,
} from "../../shared/entityFallbackUtils";
import { MisconfigStatusTab } from "../../tables/MisconfigStatusTabs";

const groupSimpleMisconfigurationsByType = (misconfigurations) => {
  return misconfigurations
    .filter(
      (misconfiguration) => !isComplexEntityType(misconfiguration.entity_type)
    )
    .reduce((acc, misconfiguration) => {
      if (!acc[misconfiguration.entity_type])
        acc[misconfiguration.entity_type] = [];
      acc[misconfiguration.entity_type].push({
        entity_id: misconfiguration.entity_id,
        display_name: misconfiguration.display_name,
        entity_type: misconfiguration.entity_type,
      });
      return acc;
    }, {});
};

const addConfigIdAndAffectedEntities = (fullControl, entitiesByType) => {
  Object.entries(entitiesByType).forEach(([_, entities]) => {
    [...entities].forEach((entity) => {
      const misconfiguration = fullControl.misconfigurations.find(
        (misconfiguration) => misconfiguration.entity_id === entity.entity_id
      );
      if (!misconfiguration) {
        entities.splice(entities.indexOf(entity), 1);
      } else {
        entity.misconfiguration_id =
          misconfiguration?.misconfiguration_id || null;
        entity.affected_entity_ids =
          misconfiguration?.affected_entity_ids || [];
        entity.extra_info = misconfiguration?.extra_info || [];
      }
    });
  });
};

const groupByStatus = (fullControl, entitiesByType) => {
  return Object.entries(entitiesByType).reduce(
    (acc, [entityType, entities]) => {
      acc[entityType] = {
        [MisconfigStatusTab.INCLUDED]: [],
        [MisconfigStatusTab.EXCLUDED]: [],
        [MisconfigStatusTab.SNOOZED]: [],
      };

      entities.forEach((entity) => {
        const misconfiguration = fullControl.misconfigurations.find(
          (misconfiguration) => misconfiguration.entity_id === entity.entity_id
        );
        const statusTab = misconfiguration.is_excluded
          ? MisconfigStatusTab.EXCLUDED
          : misconfiguration.is_snoozed
          ? MisconfigStatusTab.SNOOZED
          : MisconfigStatusTab.INCLUDED;
        acc[entityType][statusTab].push(entity);
      });

      return acc;
    },
    {}
  );
};

export const groupEntitiesByTypeAndStatus = (
  fullControl,
  misconfiguredComplexEntitiesByType,
  searchText = "",
  appliedFilters = {},
  assets = [],
  trackEvent = null
) => {
  /* 
    Result example:
    {
      "host": {
        [MisconfigStatusTab.INCLUDED]: [{}, {}, ...],
        [MisconfigStatusTab.EXCLUDED]: [{}, {}, ...],
        [MisconfigStatusTab.SNOOZED]: [{}, {}, ...],
      },
      ...  
      }
    */

  const misconfiguredSimpleEntitiesByType = groupSimpleMisconfigurationsByType(
    fullControl.misconfigurations
  );

  const complexMisconfigurationIds = fullControl.misconfigurations
    .filter((m) => isComplexEntityType(m.entity_type))
    .map((m) => m.entity_id);

  const fallbackSimpleEntities = createFallbackSimpleEntitiesFromComplexIds(
    complexMisconfigurationIds,
    misconfiguredComplexEntitiesByType,
    fullControl.control_id,
    trackEvent,
    "entities not found in DB"
  );

  const allEntitiesByType = mergeEntitiesByType(
    misconfiguredComplexEntitiesByType,
    misconfiguredSimpleEntitiesByType,
    fallbackSimpleEntities
  );

  if (Object.keys(allEntitiesByType).length === 0) {
    return null;
  }

  addConfigIdAndAffectedEntities(fullControl, allEntitiesByType);

  const searchedEntitiesByType = applySearchFilter(
    allEntitiesByType,
    searchText,
    appliedFilters,
    assets
  );
  return groupByStatus(fullControl, searchedEntitiesByType);
};
